import { render, staticRenderFns } from "./PublicIdDashboard.vue?vue&type=template&id=5eedbb47&scoped=true&"
import script from "./PublicIdDashboard.vue?vue&type=script&lang=js&"
export * from "./PublicIdDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eedbb47",
  null
  
)

export default component.exports